import React, { useState } from 'react'
import { Body, ButtonSection, ContactDesc, ContactDetails, ContactIcons, Container, Form, FormInput, FormTextArea, Heading, ImgSection, LeftSide, RightSide, SocialIconsSection, Top, SocialIcons, Name, Company, Email, Mobile, UpperForm } from './ContactElements'
import { FiPhoneCall, FiMail, FiMapPin } from "react-icons/fi";
import Button from '../Button';
import ImgBg from '../../images/body.jpeg';
import { toast, ToastContainer } from 'react-toastify';
import { FaFacebookSquare, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa'

const Contact = () => {
	const [userName, setUserName] = useState('');
	const [companyName, setCompanyName]=useState('');
	const [email, setEmail] = useState('');
	const [phoneNumber, setPhoneNumber]= useState('')
	const [subject, setSubject] = useState('');
	const [message, setMessage] = useState('');



	const handleInputNameChange = (e) => {
		const value = e.target.value;
		setUserName(value);
		console.log(JSON.stringify(value))
	};

	const handleInputCompanyChange = (e) => {
		const value = e.target.value;
		setCompanyName(value);
	};

	const handleInputEmailChange = (e) => {
		const value = e.target.value;
		setEmail(value);
		console.log(JSON.stringify(value))
	};

	const handleInputPNumberChange = (e) => {
		const value = e.target.value;
		setPhoneNumber(value);
	};

	const handleInputSubjectChange = (e) => {
		const value = e.target.value;
		setSubject(value);
	};

	const handleInputMessageChange = (e) => {
		const value = e.target.value;
		setMessage(value);
	};

	// const toastTest =()=>{
	// 	toast.success('Hellow')
	// }

	const handleContact = (e) => {
		e.preventDefault();

		const recipient = "info@africomltd.com";
		const subjectEncoded = encodeURIComponent(subject || "Contact Request");
		const bodyEncoded = encodeURIComponent(
			`Name: ${userName}\nCompany: ${companyName}\nEmail: ${email}\nPhone: ${phoneNumber}\n\nMessage:\n${message}`
		);

		const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}&su=${subjectEncoded}&body=${bodyEncoded}`;

		// Open Gmail in a new tab
		window.open(gmailURL, '_blank');

		// Optionally clear the form
		setUserName("");
		setCompanyName("");
		setEmail("");
		setPhoneNumber("");
		setSubject("");
		setMessage("");
	};


	// const handleContact = async (e) => {
	// 	e.preventDefault();
	// 	const reqBody = {
	// 		userName,
	// 		companyName,
	// 		email,
	// 		phoneNumber,
	// 		subject,
	// 		message
	// 	}
	// 	try {
	// 		const response = await fetch('/send-email',{
	// 			method: 'POST',
	// 			headers:{
	// 				"Content-Type": "application/json",
	// 			},
	// 			body:JSON.stringify(reqBody),
	// 		});
	// 		const data = await response.json();
	// 		console.log("Response data:", data);
	// 		if(response.ok){
	// 			toast.success(data.message);
	// 		}else{
	// 			toast.error(data.error || "Failed to send your message.");
	// 		}
	// 		setUserName("");
	// 		setCompanyName("");
	// 		setEmail("");
	// 		setPhoneNumber("");
	// 		setSubject("");
	// 		setMessage("");
	// 	} catch (error) {
	// 		console.log("Error on fail", error);			
	// 	}
	// }


	return (
		<Container style={{ backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.4)15%, rgba(0,0,0,0.1)), url(${ImgBg})` }}>
			<Top>
				<Heading style={{ color: "#00D3D3" }}>
					Don't be a stranger
				</Heading>
				<i>
					{" "}
					<Heading> say hello</Heading>
				</i>
			</Top>
			<Body>
				<LeftSide>
					<ImgSection />

					<ContactDetails>
						<ContactIcons>
							<FiMail />
						</ContactIcons>
						<ContactDesc>
							<a
								href="mailto:info@africomltd.com?subject=Service Inquiry&body=Hi! I am interested in knowing more about your services. Please call me back"
								// href="mailto:arnonotieno17@gmail.com?subject=Service Inquiry&body=Hi! I am interested in knowing more about your services. Please call me back"
								rel="noreferrer"
								target="_blank"
								title="Send us a mail"
							>
								info@africomltd.com
							</a>
						</ContactDesc>
					</ContactDetails>

					<ContactDetails>
						<ContactIcons>
							<FiMapPin />
						</ContactIcons>

						<ContactDesc>
							<a
								href="https://maps.app.goo.gl/xTC28KWbawYskkQKA"
								rel="noreferrer"
								target="_blank"
								title="Open on google maps"
							>
								{" "}
								Bishop magua center 4th floor,Ngong road
							</a>
						</ContactDesc>
					</ContactDetails>
					{/* <button onClick={toastTest}>click</button> */}

					<ContactDetails>
						<ContactIcons>
							<FiPhoneCall />
						</ContactIcons>
						<ContactDesc>+254 716 000 005</ContactDesc>
					</ContactDetails>

					<ContactDetails>
						<SocialIconsSection>
							<SocialIcons to="/contact" aria-label="Instagram">
								<a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
									<FaInstagram />
								</a>	
							</SocialIcons>

							<SocialIcons aria-label="Twitter">
								<a href="https://twitter.com/?lang=en" target="_blank" rel="noopener noreferrer">
									<FaTwitter />
								</a>	
							</SocialIcons>
							
							<SocialIcons aria-label="Linkedin">
								<a href="https://www.linkedin.com/company/africom-media-ltd/about/" target="_blank" rel="noopener noreferrer">
									<FaLinkedinIn />
								</a>
							</SocialIcons>

							
							<SocialIcons  aria-label="Facebook">
								<a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
									<FaFacebookSquare />
								</a>	
							</SocialIcons>
						</SocialIconsSection>
					</ContactDetails>
				</LeftSide>

				<RightSide>
					<Form onSubmit={(e) => handleContact(e)}>
						<UpperForm>
							<Name>
								<FormInput
									type="text"
									placeholder="Full Name"
									value={userName}
									onChange={handleInputNameChange}
									required
								/>
							</Name>

							<Company>
								<FormInput
									type="text"
									placeholder="Company"
									value={companyName}
									onChange={handleInputCompanyChange}
									required
								/>
							</Company>

							<Email>

								<FormInput
									type="email"
									value={email}
									onChange={handleInputEmailChange}
									placeholder="Email (xyz@abc.com)"
									required
								/>
							</Email>

							<Mobile>
								<FormInput
									type="tel"
									id="phone"
									name="phone"
									minLength="9"
									maxLength='10'
									pattern="[0-9]*"
									value={phoneNumber}
									onChange={handleInputPNumberChange}
									placeholder="+254700000000  (9+ digit)"
									required
								/>
							</Mobile>
						</UpperForm>

						<FormInput
							style={{ width: "95%" }}
							type="text"
							placeholder="Subject"
							value={subject}
							onChange={handleInputSubjectChange}
							required
						/>

						<FormTextArea
							cols="30"
							rows="5"
							style={{ width: "95%" }}
							placeholder="Message"
							onChange={handleInputMessageChange}
							value={message}
							required
						/>

						<ButtonSection>
							<Button title="Submit" />
						</ButtonSection>
					</Form>
				</RightSide>
			</Body>
			<ToastContainer />
		</Container>
	);
}

export default Contact
